import { Platform } from 'react-native';
import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { getParameters, isFromAndroidWebview, nextStepCredStepper } from "../../../configs/utils";
import _ from 'lodash';
let hasNavigate = false;
export const CameraConfirmAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CAMERA_CAPTURE);
};
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const retakePhoto = async (action, _datastore, { setDatastore, navigate, instrumentTrack }) => {
    instrumentTrack('CAPTURE_SELFIE_RETAKE_BUTTON_CLICKED');
    await setDatastore(ROUTE.CAMERA_CAPTURE, 'camera', {
        isShowVideo: true,
    });
    await navigate(ROUTE.CAMERA_CAPTURE);
};
export const photoVerification = async (action, _datastore, { network, navigateWithClear, setDatastore, showPopup, instrumentTrack }) => {
    await setDatastore(action.routeId, 'kycPhotoInit', {
        loading: true,
    });
    const SUCCESS = 'SUCCESS';
    const DEVIATION = 'DEVIATION';
    const REJECTED = 'REJECTED';
    const user = await SharedPropsService.getUser();
    const imageName = `${user.linkedApplications[0].applicationId}_${user.linkedBorrowerAccounts[0].accountHolderPhoneNumber}.txt`;
    /** Generate Image Upload Link */
    const imageUploadLinkResponse = await network.post(api.photoInit, {
        applicationId: user.linkedApplications[0].applicationId,
        imageName,
        imageType: 'image/jpeg',
    }, { headers: await getAppHeader() });
    if (imageUploadLinkResponse.status === 200) {
        /** Image Link Generated Successful **/
        if (!imageUploadLinkResponse.data.stepResponseObject)
            return;
        /** Upload Image to Generated Link **/
        const imageUploadResponse = await network.put(imageUploadLinkResponse.data.stepResponseObject, action.payload.base64Image, {
            headers: { 'Content-Type': 'image/jpeg' },
        });
        if (imageUploadResponse.status === 200) {
            /** Image Uploaded Successfully **/
            const imageVerifyResponse = await network.post(api.photoVerify, {
                applicationId: user.linkedApplications[0].applicationId,
            }, { headers: await getAppHeader(),
                handleFromMF: true });
            if (imageVerifyResponse.status === 200) {
                await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                    showPhotoVerificationErrorCard: false,
                    errorTitle: "",
                    errorMessage: "",
                    counter: Math.random(),
                });
                const status = imageVerifyResponse?.data?.stepResponseObject?.status;
                if (status === SUCCESS) {
                    user.linkedApplications[0] = _.get(imageVerifyResponse, 'data.updatedApplicationObj');
                    await SharedPropsService.setUser(user);
                    instrumentTrack('LOAN_APPLICATION_SUBMIT_BUTTON_CLICKED');
                    const routeObj = await nextStepCredStepper();
                    setTimeout(async () => {
                        !hasNavigate &&
                            navigateWithClear(routeObj.routeId, routeObj.params);
                        // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                        //     loading: false
                        // })
                    }, 3000);
                    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                        kycPhotoUploadSuccess: true,
                    });
                }
                else if (status === DEVIATION) {
                    await navigateWithClear(ROUTE.PHOTO_MISMATCH);
                    // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                    //     loading: false
                    // })
                }
                else if (status === REJECTED) {
                    // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                    //     loading: false
                    // })
                    const errorTitle = imageVerifyResponse?.data?.stepResponseObject?.error?.errorTitle;
                    const errorMessage = imageVerifyResponse?.data?.stepResponseObject?.error?.errorMessage;
                    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                        showPhotoVerificationErrorCard: true,
                        errorTitle: errorTitle,
                        errorMessage: errorMessage,
                        counter: Math.random()
                    });
                }
            }
            else {
                // await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", <KycInitProps>{
                //     loading: false
                // })
                const errorMessage = imageVerifyResponse?.response?.data?.message;
                await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
                    showPhotoVerificationErrorCard: true,
                    errorTitle: "Verification failed",
                    errorMessage: errorMessage,
                    counter: Math.random()
                });
            }
        }
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    let isFromTdl = false;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        if (params.platform === "TATADIGITAL" /* AppPlatform.TDL */) {
            isFromTdl = true;
        }
        if (isFromAndroidWebview() && isFromTdl) {
            window.open("FAQ_CLICKED", "_parent");
            //@ts-ignore
        }
        else {
            await navigate(ROUTE.CONTACT_US_CARD);
        }
        // @ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ");
    }
    else {
        await navigate(ROUTE.CONTACT_US_CARD);
    }
};
export const successVerification = async (action, _datastore, { goBack, navigate }) => {
    hasNavigate = true;
    const routeObj = await nextStepCredStepper();
    navigate(routeObj.routeId, routeObj.params);
};
export const onModalCloseAction = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.KYC_PHOTO_VERIFICATION, "kycPhotoInit", {
        loading: false
    });
};
